module.exports = __webpack_public_path__ + "img/clothing209.b59aebfb.jpg";